import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import ConnectAPI from "../../../services/api";

const connectApi = new ConnectAPI();
function SpecialConditionDetailTypes_16  ({ specialCondition }) {
    const { t, i18n } = useTranslation();
    const [tableData, setTableData] = useState([]);
    var fetchData;
    useEffect(() => {
        
        fetchData = () => {
            connectApi.getWithParams("api/Channels/specialConditionMaximumCostPerImpression", specialCondition.idSpecialCondition, getSCdataCallback)
                .catch((error) => {
                    Swal.fire(
                        "Error " + error?.response?.status,
                        error?.response?.data,
                        "error"
                    );
                });
        }
        fetchData();
        
    }, [specialCondition.idSpecialCondition]);
    
    let optDecimal = {
        style: 'decimal',
        maximumFractionDigits: 5
    };
    let getSCdataCallback;
    getSCdataCallback = (status, data) => {
        if(specialCondition.idSpecialConditionType==18)
            data.forEach(obj => {
                obj.minPrint = `${(Math.floor(obj.minPrint))} %`;
                obj.maxPrint = `${(Math.floor(obj.maxPrint))} %`;
            });
        setTableData(data);
    }
    return (<>
        {specialCondition.idSpecialConditionType==18?(
            <table className="table table-striped table-hover table-bordered table-sm " >
                <thead>
                    <tr>
                        <th scope="col" className="text-center">
                            Min Print
                        </th>
                        <th scope="col" className="text-center">
                            Max Print
                        </th>
                        <th scope='col' className='text-center'>1Col</th>
                        <th scope='col' className='text-center'>2Col</th>
                        <th scope='col' className='text-center'>EPM</th>
                        <th scope='col' className='text-center'>Multicolor</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, index)=>{
                        return (
                            <tr>
                                <td scope='col'>{row.minPrint.toLocaleString()}</td>
                                <td scope='col'>{row.maxPrint.toLocaleString()}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.oneCol)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.twoCol)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.epm)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.multicolor)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        ):(
            <table className="table table-striped table-hover table-bordered table-sm " >
                <thead>
                    <tr>
                        <th scope="col" className="text-center">
                            Min Print
                        </th>
                        <th scope="col" className="text-center">
                            Max Print
                        </th>
                        <th scope='col' className='text-center'>Black CPP</th>
                        <th scope='col' className='text-center'>Other CPP</th>
                        <th scope='col' className='text-center'>One Shot CPP</th>
                        <th scope='col' className='text-center'>White CPP</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((row, index)=>{
                        return (
                            <tr>
                                <td scope='col'>{row.minPrint.toLocaleString()}</td>
                                <td scope='col'>{row.maxPrint.toLocaleString()}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.blackCpp)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.otherCpp)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.oneShotCpp)}</td>
                                <td scope='col'>{new Intl.NumberFormat('en-US', optDecimal).format(row.whiteCpp)}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )}
        *<label style={{fontSize: '12px'}} >{t("note_table")}</label>
        <br/>
    </>);
    
    
}

export default SpecialConditionDetailTypes_16;